module.exports = __webpack_public_path__ + "static/img/m_ph03.23006ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/drawn/m_ph03.jpg
// module id = 0Yzn
// module chunks = 0